<template>
  <div class="container-fluid" data-spy="scroll" v-if="rol == 2 || rol == 1">
    <nav
      class="navbar navbar-expand-lg navbar-dark border"
      style="background: #336699; color: #ffffff"
    >
      <div class="container-fluid" style="background: #336699; color: #ffffff">
        <a
          class="navbar-brand"
          href="#"
          style="background: #336699; color: #ffffff"
          >HC</a
        >
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse"
          id="navbarNavDropdown"
          style="background: #336699; color: #ffffff"
        >
          <ul class="navbar-nav" style="background: #336699; color: #ffffff">
            <li class="nav-item" v-if="verpagina != 0" @click="menuCabecera(1)">
              <a
                class="nav-link active"
                aria-current="page"
                href="#"
                style="background: #336699; color: #ffffff"
                >Listar</a
              >
            </li>
            <li class="nav-item" v-if="verpagina == 0" @click="menuCabecera(2)">
              <a
                class="nav-link"
                href="#"
                style="background: #336699; color: #ffffff"
                >Nuevo</a
              >
            </li>
            <!--
            <li class="nav-item">
              <a class="nav-link" href="#" style="background: #336699; color:#ffffff">Pricing</a>
            </li>
            -->
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <div class="container-fluid" data-spy="scroll" v-if="rol == 2 || rol == 1">
    <div class="card bg-white">
      <template v-if="verpagina == 0">
        <div class="card-body">
          <div class="form-group row">
            <div class="container">
              <div class="card">
                <!--
                <div class="card-header border text-start fw-bold">
                  -->
                <div class="card-body">
                  <div class="row content">
                    <!--
                    <div class="text-star col-md-1">
                      <label
                        class="text-star labelRC"
                        style="
                          background: #ffffff;
                          padding: 10px 0;
                          font-size: 11px;
                          inline-size: auto;
                        "
                        >Buscar&nbsp;por:</label
                      >
                    </div>
                    <div class="text-star col-md-3">
                      <input
                        type="radio"
                        id="Nombre"
                        value="Nombre"
                        v-model="selectFilterLike"
                        @change="seleccionarProdCB()"
                      />
                      <label
                        class="text-star labelRC"
                        for="Nombre"
                        style="width: 210px"
                        >Nombre&nbsp;del&nbsp;formulario</label
                      >
                    </div>
                    <div class="text-star col-md-2">
                      <input
                        type="radio"
                        id="Productos"
                        value="Productos"
                        v-model="selectFilterLike"
                        @change="seleccionarProdCB()"
                      />
                      <label
                        class="text-star labelRC"
                        for="Productos"
                        style="width: 160px"
                        >Productos</label
                      >
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div v-if="selectPCB == 1" class="col-md-5">
                      <div class="contentS row">
                        <div class="text-star col-md-6">
                          <input
                            type="checkbox"
                            id="radio3"
                            name="radio03"
                            class="chk-cb"
                            true-value="1"
                            false-value="0"
                            v-model="selectCond"
                            @click="seleccionarProd(1)"
                          />
                          <label class="labelRCB" for="radio3"
                            >Condición&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label
                          >
                        </div>
                        <div class="text-star col-md-6">
                          <input
                            type="checkbox"
                            id="radio4"
                            name="radio04"
                            class="chk-cb"
                            true-value="1"
                            false-value="0"
                            v-model="selectBenef"
                            @click="seleccionarProd(2)"
                          />
                          <label class="labelRCB" for="radio4"
                            >Beneficio&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label
                          >
                        </div>
                      </div>
                    </div>

                  -->

                    <div class="form-group row input-group col-md-12">
                      <div class="input-group col-md-12">
                        <div>
                          <div
                            class="text-start"
                            style="
                              height: 25px;
                              font-size: 11px;

                              padding-top: 0px;
                              font-weight: bold;
                            "
                          >
                            <label style="width: 100%"
                              >Ingresar&nbsp;búsqueda:</label
                            >
                          </div>
                          <input
                            type="text"
                            class="inputText border"
                            v-model="buscarlike"
                            placeholder="Ingresar búsqueda"
                            style="font-size: 12px; width: 100%; height: 32px"
                            @keyup.enter="listarPromocionesLikeCB(1)"
                            title="Ingresar nombre/código"
                          />
                        </div>

                        <div>
                          <div
                            class="text-start"
                            style="
                              height: 25px;
                              font-size: 11px;

                              padding-top: 1px;
                              font-weight: bold;
                            "
                          >
                            &nbsp;
                          </div>
                          <button
                            type="submit"
                            @click="procesarPromosBusqueda()"
                            class="btn btn-secondary"
                            style="font-size: 12px; height: 32px"
                          >
                            <i class="fa fa-search"></i> Buscar</button
                          >&nbsp;&nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--
                </div>
                -->

                <div class="card-body border">
                  <div class="table-responsive">
                    <table class="table table-bordered table-sm" width="100%">
                      <thead>
                        <tr>
                          <th class="card-body">Acciones</th>
                          <th class="card-body">Cédula</th>
                          <th class="card-body">Apellidos Nombres</th>
                          <th class="card-body">Cargo</th>
                          <th class="card-body">Sucursal</th>
                          <th class="card-body">Fecha de ingreso</th>
                          <th class="card-body">Estado</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(formul, index) in arrayPromocionesAll"
                          :key="index"
                        >
                          <td>
                            <div class="btn-group btn-sm border">
                              <button
                                type="button"
                                class="btn btn-sm"
                                style="font-size: 11px"
                              >
                                <i class="fas fa-tools"></i>
                              </button>
                              <button
                                type="button"
                                class="btn dropdown-toggle dropdown-toggle-split btn-sm"
                                id="dropdownMenuReference"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                data-bs-reference="parent"
                              >
                                <span class="visually-hidden"
                                  >Toggle Dropdown</span
                                >
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuReference"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    style="font-size: 12px"
                                    v-if="
                                      formul.estado != 'Cancelado' &&
                                      formul.estado != 'Generado' &&
                                      formul.estado != 'Rechazado'
                                    "
                                    @click="editarEmpleado(formul)"
                                    ><i class="fas fa-pencil-alt"></i
                                    >&nbsp;Editar</a
                                  >
                                </li>
                                <!--
                                <li>
                                  <a
                                    class="dropdown-item"
                                    style="font-size: 12px"
                                    @click="
                                      duplicarFormulario(
                                        formul.codigoFormulario
                                      )
                                    "
                                    ><i class="far fa-clone"></i
                                    >&nbsp;Duplicar</a
                                  >
                                </li>

                                <li>
                                  <a
                                    v-if="
                                      formul.estado != 'Cancelado' 
                                    "
                                    class="dropdown-item"
                                    style="font-size: 12px"
                                    @click="abrirModalFormulario(formul, 1)"
                                    ><i class="fas fa-door-closed"></i
                                    >&nbsp;Cancelar</a
                                  >
                                </li>
                                <li><hr class="dropdown-divider" /></li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    style="font-size: 12px"
                                    @click="seguimientoformulario(formul)"
                                    ><i class="fa fa-bars"></i
                                    >&nbsp;Seguimiento</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    style="font-size: 12px"
                                    @click="verFormulario(formul)"
                                    ><i class="fa fa-eye"></i>&nbsp;Ver</a
                                  >
                                </li>
                                -->
                                <li><hr class="dropdown-divider" /></li>
                                <li>
                                  <a
                                    v-if="
                                      formul.estado != 'Cancelado' &&
                                      formul.estado != 'Pendiente'
                                    "
                                    class="dropdown-item"
                                    style="font-size: 12px"
                                    @click="
                                      downloadformulario11(
                                        formul.codigoFormulario
                                      )
                                    "
                                    ><i class="fa fa-download"></i
                                    >&nbsp;Eliminar</a
                                  >
                                </li>
                              </ul>
                            </div>
                          </td>
                          <td v-text="formul.numdocumento"></td>
                          <td >{{formul.apellidos}}&nbsp;{{ formul.nombres }}</td>
                          <td v-text="formul.cargo"></td>
                          <td v-text="formul.sucursal"></td>
                          <td v-text="formul.fechaingreso"></td>
                          <td v-text="formul.estado"></td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="arrayPromocionesAll.length < 5">
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                    </div>

                    <nav
                      v-if="paginasTotal > 0"
                      aria-label="Page navigation example"
                    >
                      <ul class="pagination">
                        <li class="page-item">
                          <a class="page-link" href="#" @click="prevPage()"
                            ><i class="fas fa-fast-backward"></i
                          ></a>
                        </li>
                        <li
                          v-for="n in paginasTotal"
                          :key="n"
                          class="page-item list-group-item-secondary"
                        >
                          <a
                            class="page-link"
                            href="#"
                            @click="fitrarPromociones(n)"
                            >{{ n }}</a
                          >
                        </li>

                        <li class="page-item">
                          <a class="page-link" href="#" @click="nextPage()"
                            ><i class="fas fa-fast-forward"></i
                          ></a>
                        </li>
                        <li>
                          <a class="page-link" href="#">
                            &nbsp;&nbsp;<i></i>Página ({{ paginaActiva }})
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div class="card-footer text-muted justify-content-md-end">
                  <div class="form-control-sm row" style="height: 1px">
                    <div class="col-md-10 text-center"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- Página uno -->
      <template v-if="verpagina == 1">
        <div class="card-body">
          <div class="form-group row">
            <div class="container">
              <div class="card">
                <div class="card-header border text-start fw-bold">
                  <h6 style="color: #ff7f00">Datos del Usuario</h6>
                </div>
                <div class="card-body border">
                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class=""> Buscar:</label>
                    </div>
                    <div class="col-md-4">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        v-model="numdocumento"
                        placeholder="Ingrese número de cédula a buscar"
                        required
                        @keyup.enter="buscarPacienteHC()"
                      />
                    </div>
                    <div class="col-md-2">
                      <button
                        type="submit"
                        @click="buscarPacienteHC()"
                        class="btn btn-secondary"
                        style="font-size: 12px; height: 32px"
                      >
                        <i class="fa fa-search"></i> Buscar</button
                      >&nbsp;&nbsp;
                    </div>
                  </div>

                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Num Documento: </label>
                    </div>
                    <div class="col-md-4">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="CI/Pasaporte"
                        v-model="numdocumento"
                        required
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Apellidos: </label>
                    </div>
                    <div class="col-md-4">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="Apellidos del paciente"
                        v-model="apellidos"
                        required
                        readonly
                      />
                    </div>
                    <div class="col-md-2 text-end">
                      <label class="">Nombres: </label>
                    </div>
                    <div class="col-md-4">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="Nombres del paciente"
                        v-model="nombres"
                        required
                        readonly
                      />
                    </div>
                  </div>
                  <hr style="height: 1px" />
                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Sucursal: </label>
                    </div>
                    <div class="col-md-2">
                      <select
                        class="form-select form-control-sm"
                        v-model="sucursal"
                        style="font-size: 12px"
                      >
                        <option
                          v-for="variable in arraySucursal"
                          :key="variable.id"
                          :value="variable.sucursal"
                          v-text="variable.sucursal"
                        ></option>
                      </select>
                    </div>
                  </div>
                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Cargo: </label>
                    </div>
                    <div class="col-md-2">
                      <select
                        class="form-select form-control-sm"
                        v-model="cargo"
                        style="font-size: 12px"
                      >
                        <option
                          v-for="variable in arrayCargo"
                          :key="variable.id"
                          :value="variable.cargo"
                          v-text="variable.cargo"
                        ></option>
                      </select>
                    </div>
                  </div>

                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Jornada: </label>
                    </div>
                    <div class="col-md-3">
                      <select
                        class="form-select form-select-sm form-control inputText"
                        v-model="jornada"
                        required
                      >
                        <option value="0" disabled>Seleccione</option>
                        <option value="Matutina">Matutina</option>
                        <option value="Vespertina">Vespertina</option>
                        <option value="Completa">Completa</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Seguro: </label>
                    </div>
                    <div class="col-md-3">
                      <select
                        class="form-select form-select-sm form-control inputText"
                        v-model="seguro"
                        required
                      >
                        <option value="0" disabled>Seleccione</option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Aseguradora: </label>
                    </div>
                    <div class="col-md-3">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="Aseguradora"
                        v-model="aseguradora"
                        required
                      />
                    </div>
                    <div class="col-md-2 text-end">
                      <label class="">Num. afiliación </label>
                    </div>
                    <div class="col-md-3">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="Num. afiliación "
                        v-model="numeroafiliacion"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-control-sm row">
                    <div class="col-md-2 text-end">
                      <label class="">Fecha ingreso: </label>
                    </div>
                    <div class="col-md-2">
                      <input
                        type="date"
                        class="form-control form-control-sm inputText"
                        v-model="fechaingreso"
                        required
                      />
                    </div>
                    <div class="col-md-2 text-end">
                      <label class="">Fecha salida: </label>
                    </div>
                    <div class="col-md-2">
                      <input
                        type="date"
                        class="form-control form-control-sm inputText"
                        v-model="fechasalida"
                        required
                      />
                    </div>
                  </div>

                  <hr style="height: 1px" />
                </div>
                <div class="card-body border">
                  <div class="form-control-sm row" style="height: 1px">
                    <div class="col-md-10 text-end"></div>
                    <div class="col-md-2 text-end">
                      <label
                        class="btn btn-outline-primary btn-sm inpuText"
                        @click="registrarEmpleado()"
                      >
                        <i class="far fa-save"></i>&nbsp;Guardar
                      </label>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-muted justify-content-md-end">
                  <div class="form-control-sm row" style="height: 1px">
                    <div class="col-md-1 text-center" style="font-size: 12px">
                      Pag:&nbsp;{{ paginaFormulario }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- Fin página uno -->
    </div>
  </div>
</template>
<script>
import "@/assets/styleRC.css";
import axios from "axios";
import IPServie from "../service/ConectionDataService";
import TextReaderP from "../service/TextReaderProducto";
import TextReaderC from "../service/TextReaderCiudad";
import TextReaderO from "../service/TextReaderOficina";
import TextReaderPr from "../service/TextReaderProvincia";
//import TextReaderR from "../service/TextReaderRegion";
//import TextReaderS from "../service/TextReaderSucursal";
import TextReaderSc from "../service/TextReaderSegmento";

import FechaService from "../service/FechaService";

import * as XLSX from "xlsx";

export default {
  name: "App",
  data() {
    return {
      //filter
      filtrarLike: "Nombre",
      selectFilterLike: "Nombre",
      selectPCB: 0,
      selectCond: 1,
      selectBenef: 1,
      buscarlike: "",
      buscarEstado: "Estado",
      buscarModalidad: "0",
      //array
      arrayFechasprocesos: [],
      //arrays
      arrayPromocionesAll: [],
      arrayPromocionesAll_all: [],
      arrayPromocionesAll_pag: [],
      arrayPromocionesAll_ES: [], // estado
      arrayPromocionesAll_MD: [], //  modalidad
      //
      paginasTotal: 10,
      obj_per_page: 50,
      paginaActiva: 1,
      controlPaginas: 0,

      http_: "",
      ///Paciente
      tipodocumento: "",
      numdocumento: "",
      codigoPaciente: 0,

      apellidos: "",
      nombres: "",
      edad: "",
      fechanacimiento: "",
      tiposangre: "",
      genero: "0",
      estadocivil: "0",
      telefono: "",
      celular: "",
      operadora: "0",
      telefonoemergencia: "",
      correo: "",
      nacionalidad: "0",
      ciudad: "",
      direccion: "",
      referenciaubicacion: "",
      religion: "",
      ocupacion: "",

      /// Usuario
      login: "",
      password: "",
      roluser: 0,
      codigoUser: 0,
      nombresapellidos: "",
      rol: 0,

      /////7
      spinnerControl: 0,
      verpagina: 0,
      usuario: "",
      usuarioModifica: "",
      codigoFormulario: "0",
      ///   Empleado
      codigoEmpleado:0,
      fechaingreso: "",
      fechasalida: "",
      tipocontratacion: "",
      sucursal: "",
      jornada: "Completa",
      cargo: "Administrador",
      seguro: "SI",
      aseguradora: "",
      numeroafiliacion: "",
      usuarioultimo: "",
      estado: "ACTIVO",
      arraySucursal: [],
      arrayCargo: [],
      //
      empresa_RUC: "",
      empresa_NC: "",
      //carga de excel
      arrayFileXLS: [],
    };
  },
  methods: {
    handleFileUpload(event) {
      let arrayFileXLSTemp = [];
      let listCodigosTemp = "";
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const fileData = reader.result;
        const workbook = XLSX.read(fileData, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        //this.arrayFileXLS.push(sheetData);
        arrayFileXLSTemp.push(sheetData);
        //console.log(sheetData);
        arrayFileXLSTemp = sheetData;
        console.log(sheetData);
        for (let i = 0; i < sheetData.length; i++) {
          listCodigosTemp = listCodigosTemp + sheetData[i].CODIGO + ",";
        }
        console.log(listCodigosTemp);
        this.listaCodigos = listCodigosTemp.substring(
          0,
          listCodigosTemp.length - 1
        );
      };

      reader.readAsBinaryString(file);
      /*
      console.log(arrayFileXLSTemp);
      for(let i=0; i<arrayFileXLSTemp.length;i++){
        listCodigosTemp = listCodigosTemp + arrayFileXLSTemp[i].CODIGO;
      }
      console.log(listCodigosTemp);
      */
    },

    menuCabecera(valor) {
      let me = this;
      if (valor == 1) {
        me.verpagina = 0;
        me.listarEmpleados();
      }
      if (valor == 2) {
        me.limpiarFormulario();
        me.verpagina = 1;
      }
    },
    limpiarFormulario() {
      let me = this;
      me.verpagina = 1;
      me.codigoPaciente = 0;
      me.codigoEmpleado=0;
      me.tipodocumento = "0";
      me.numdocumento = "";
      me.fechaInicioSistema = FechaService.fechaHoy();
      me.fecharegistro = FechaService.fechaHoy();
      me.apellidos = "";
      me.nombres = "";
      me.cargo = "Administrador";
      me.sucursal = "IBARRA";
      me.jornada= "Completa";
      me.seguro= "SI";
      me.fechaingreso= "";
      me.fechasalida= "";
     

      me.cargaParametros();
    },
    cargaParametros() {
      let me = this;
      me.listarEmpleados();
      me.cargarSucursal();
      me.cargarCargo();
      /*
      me.listarGeneraCobro();
      me.listaTitlePopUp();
      me.listarAsumeCategoria();
      me.listarResponsable();
      me.listarLineaComercial();
      me.listarProveedores();
      
      me.listarNegociador();
      me.verEmpresa();
      */
    },

    cargarCargo() {
      let me = this;
      var url = me.http_ + "/APIHC/parametros/allCargo";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arrayCargo = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    cargarSucursal() {
      let me = this;
      var url = me.http_ + "/APIHC/parametros/allSucursal";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arraySucursal = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verEmpresa() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/empresa/allActive";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.empresa_RUC = response.data.ruc;
          me.empresa_NC = response.data.nombre_razon;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    registrarEmpleado() {
      let me = this;
      var url = ""; // me.http_ + "/APIHC/persona/save";

      if (me.codigoEmpleado == 0) {
        url = me.http_ + "/APIHC/empleados/save";
        //me.asignarPadre();
      } else {
        url = me.http_ + "/APIHC/empleados/update";
      }

      me.$swal({
        position: "top-end",
        title: "Está seguro de crear al empleado ?",
        text: "¡..!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(url, {
              id: me.codigoEmpleado,
              personasId: me.codigoPaciente,
              numdocumento:me.numdocumento,
              nombres:me.nombres,
              apellidos:me.apellidos,
              sucursal: me.sucursal,
              fechaingreso: me.fechaingreso,
              jornada: me.jornada,
              cargo: me.cargo,
              seguro: me.seguro,
              aseguradora: me.aseguradora,
              numeroafiliacion: me.numeroafiliacion,
              usuario: me.usuario,
              usuarioultimo: me.usuarioultimo,

            })
            .then(function (response) {
              var respuesta = response.data;
              console.log(respuesta);
              if (respuesta != "") {
                me.codigoPaciente = respuesta.id;
                //me.verpagina = 2;
                me.verpagina = 0;
                me.listarEmpleados();
              } else {
                me.$swal({
                  position: "top-end",
                  icon: "warning",
                  title: "Empleado no resgistrado.",
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              me.$swal({
                position: "top-end",
                icon: "success",
                title: "Empleado no resgistrado. NO HAY CONECCIÓN.. ",
                showConfirmButton: false,
                timer: 3000,
              });
            });
        }
      });
    },
    editarEmpleado(frm) {
      let me = this;
      me.codigoEmpleado = frm.id;
      me.codigoPaciente = frm.personasId;

      //me.tipodocumento = frm.tipodocumento;
      me.numdocumento = frm.numdocumento;
      
      me.apellidos = frm.apellidos;
      me.nombres = frm.nombres;
      /*
      me.edad = frm.edad;
      me.fechanacimiento = frm.fechanacimiento.substring(0, 10);
      me.tiposangre = frm.tiposangre;
      me.genero = frm.genero;
      me.estadocivil = frm.estadocivil;
      me.telefono = frm.telefono;
      me.celular = frm.celular;
      me.operadora = frm.operadora;
      me.telefonoemergencia = frm.telefonoemergencia;
      me.correo = frm.correo;
      me.nacionalidad = frm.nacionalidad;
      me.ciudad = frm.ciudad;
      me.direccion = frm.direccion;
      me.referenciaubicacion = frm.referenciaubicacion;
      me.religion = frm.religion;
      me.ocupacion = frm.ocupacion;*/

      me.cargo=frm.cargo;
      me.fechaingreso=frm.fechaingreso;
      me.fechasalida=frm.fechasalida;
      me.tipocontratacion = frm.tipocontratacion;
      me.sucursal = frm.sucursal;
      me.jornada = frm.jornada;
      me.cargo = frm.cargo;
      me.seguro = frm.seguro;
      me.aseguradora=frm.aseguradora;
      me.numeroafiliacion=frm.numeroafiliacion;
      me.usuario = frm.usuario;

      me.fechaInicioSistema = FechaService.fechaHoy();
      me.paginaFormulario = 1;
      me.verpagina = 1;


      //me.listarFile();
    },
    buscarPacienteHC() {
      let me = this;
      var url;
      url = me.http_ + "/APIHC/persona/getPersona/" + me.numdocumento;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //me.arraryBuscarLike = response.data;
          me.codigoPaciente = response.data.id;
          me.apellidos = response.data.apellidos;
          me.nombres = response.data.nombres;
          me.edad = response.data.edad;
          me.genero = response.data.genero;
          me.telefono = response.data.telefono;
          me.celular = response.data.celular;
          me.correo = response.data.correo;
          me.telefonoemergencia = response.data.telefonoemergencia;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarEmpleados() {
      let me = this;
      me.verpagina = 0;
      var url = me.http_ + "/APIHC/empleados/all";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arrayFormularioAll = response.data;

          me.arrayFormularioFilter = response.data;
          //console.log(me.arrayFormularioFilter);
          //
          me.arrayPromocionesAll_all = response.data;
          me.arrayPromocionesAll = response.data;
          me.arrayPromocionesAll_pag = response.data;
          //console.log(me.arrayPromocionesAll_all.length);
          me.paginasTotal = Math.ceil(
            me.arrayPromocionesAll_all.length / me.obj_per_page
          );
          me.arrayPromocionesAll_ES = response.data;
          me.arrayPromocionesAll_MD = response.data;
          //console.log(me.arrayPromocionesAll_ES);
          //console.log(me.arrayPromocionesAll_MD);
          me.fitrarPromociones(1);
          //
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    sigPagForm(pag) {
      let me = this;
      me.verpagina = pag + 1;
      me.paginaFormulario = me.verpagina;
      if (me.verpagina == 3) {
        me.recorrerArbolCondicion(me.grupoCondiciones);
      }
    },
    antPagForm(pag) {
      let me = this;
      me.verpagina = pag - 1;
      me.paginaFormulario = me.verpagina;
    },

    ////////////////////
    async uploadFile(event) {
      let me = this;
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("clave", me.codigoFormulario);
      let url = this.http_ + "/formularionego/upload-pdf";

      try {
        await axios.post(url, formData);
        me.listarFile();
        console.log("PDF uploaded successfully");
      } catch (error) {
        console.error(error);
      }
    },
    async listarFile() {
      let me = this;
      var url = me.http_ + "/formularionego/listarFile/" + me.codigoFormulario;
      await axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          me.listaFiles = response.data;
          console.log(me.listaFiles);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargarFile(archivo) {
      let me = this;
      var url =
        me.http_ +
        "/formularionego/descargarFile/" +
        archivo +
        "/" +
        me.codigoFormulario;
      var archivof = archivo;
      axios
        .get(url, { fileForDownload: archivof, responseType: "blob" })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", archivof);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async eliminarFile(archivo) {
      let me = this;
      var url =
        me.http_ +
        "/formularionego/eliminarFile/" +
        archivo +
        "/" +
        me.codigoFormulario;
      await axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          me.listarFile();
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    fitrarPromociones(page) {
      let me = this;
      //console.log(page);
      me.paginaActiva = page;
      me.current_page_all = page;
      //var listing_table = document.getElementById("TableList");
      //var page_span = document.getElementById("page");
      let arraTmp = [];
      if (page < 1) page = 1;
      if (page > me.totNumPages()) page = me.totNumPages();
      //listing_table.innerHTML = "";
      for (
        var i = (page - 1) * me.obj_per_page;
        i < page * me.obj_per_page;
        i++
      ) {
        //listing_table.innerHTML += obj[i].number + "<br>";
        if (me.arrayPromocionesAll_pag[i] != null) {
          arraTmp.push(me.arrayPromocionesAll_pag[i]);
        }

        //
      }
      //console.log(arraTmp);
      me.arrayPromocionesAll = arraTmp;
    },
    totNumPages() {
      let me = this;
      return Math.ceil(me.arrayPromocionesAll_all.length / me.obj_per_page);
    },
    prevPage() {
      let me = this;
      if (me.current_page_all > 1) {
        me.current_page_all--;
        me.fitrarPromociones(me.current_page_all);
        me.paginaActiva = me.current_page_all;
      }
    },
    nextPage() {
      let me = this;
      if (me.current_page_all < me.totNumPages()) {
        me.current_page_all++;
        me.fitrarPromociones(me.current_page_all);
        me.paginaActiva = me.current_page_all;
      }
    },
    //
    selectEliminarHistorial() {
      let me = this;
      if (me.borrarHistorial) {
        me.fechaInicioAcumulacion = me.fechaInicio;
        me.disabledFecha = true;
      } else {
        me.fechaInicioAcumulacion = "";
        me.disabledFecha = false;
      }
    },
    downloadformulario(codigoFormulario) {
      let me = this;
      var url =
        me.http_ + "/formularionego/downloadformulario/" + codigoFormulario;
      var codigoFormulariolk = codigoFormulario + ".pdf";
      axios
        .get(url, { fileForDownload: codigoFormulariolk, responseType: "blob" })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", codigoFormulariolk);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    verFormulario(frm) {
      let me = this;
      me.editarEmpleado(frm);
      me.verpagina = 6;
    },
  },
  computed: {
    calcularTPCobro: function () {
      let me = this;
      var resultado = 0.0;
      console.log(me.arrayCobros.length);
      for (var i = 0; i < me.arrayCobros.length; i++) {
        resultado = resultado + me.arrayCobros[i].valor;
      }
      return resultado;
    },
  },
  mounted() {
    let me = this;
    me.http_ = IPServie.getURL();
    console.log(me.http_);
    me.cargaParametros();
    me.usuario = localStorage.getItem("userhc");
    me.rol = localStorage.getItem("rolhc");
    console.log(me.usuario + "-" + me.rol);

    
    if(me.usuario == null){
      this.$router.push('/');
      location.reload();
    }
    //me.usuarioModifica = localStorage.getItem("userf");
  },
  components: {
    TextReaderP,
    TextReaderC,
    TextReaderO,
    TextReaderPr,
    //TextReaderR,
    //TextReaderS,
    TextReaderSc,
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  width: 100%;
  color: #008dd2;
}
.mostrar {
  display: list-item !important;
  opacity: 10 !important;
  /*position: absolute !important; */
  /*background-color: #3c29297a !important;*/
}

.card-body {
  font-size: 12px;
  line-height: 25px;
  color: #008dd2;
}
.table-responsive .table {
  color: #000000;
}
.btnNext {
  background: #d4d5d5;
  border: 1px solid rgb(79, 88, 97);
  border-style: double;
  color: rgb(78, 76, 76);
}
.btnNext:hover {
  background: #c4cfe7;
  cursor: pointer;
}
.menuLocal:hover {
  cursor: pointer;
  background: #c4cfe7;
  border: PowderBlue 1px solid;
  opacity: 0.5;
  border-top-right-radius: 10px;
}
.menuLocal:active {
  opacity: 0.5;
  cursor: pointer;
  background: #ecf0f1;
  border-top-right-radius: 10px;
}
.txtArea {
  font-size: 12px;
  border-radius: 2px;
  margin: 1px;
  /** overflow: hidden; */
  resize: none;
}
</style>

<style>
a.tip {
  border-bottom: 1px dashed;
  text-decoration: none;
}
a.tip:hover {
  cursor: help;
  position: relative;
}
a.tip span {
  display: none;
}
a.tip:hover span {
  border: #c0c0c0 1px dotted;
  /*border-radius: 10px 100px / 120px;*/
  border-radius: 10px;

  padding: 2px 2px 2px 2px;
  display: block;
  z-index: 100;
  background: #f0f0f0 no-repeat 100% 5%;
  left: -100px;
  margin: 20px;
  width: 200px;
  position: absolute;
  top: 10px;
  text-decoration: none;
  font-size: 11px;
}
</style>
